import { faSignOutAlt, faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from "@material-ui/core/Switch";
import { push } from "connected-react-router";
import * as React from "react";
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { Collapse, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Label, Nav, Navbar, NavbarBrand, UncontrolledDropdown } from "reactstrap";
import { checkIfRevoultPaymentAllowed, DictlanguagesOptions, DisplayZendDeskChat } from "../../../Helpers/DataHelpers";
import { GetCompanyDataResult, LoadCompanyLogoResult } from "../../../Interfaces/Interfaces";
import { Login, Logout } from '../../../redux/actions/AuthActions';
import { ChangeLanguage } from '../../../redux/actions/languageAction';
import { enableDarkTheme, enableLightTheme } from '../../../redux/actions/themeActions';
import * as ReduxTypes from "../../../redux/constants";
import { IUserData } from '../../../redux/constants';

declare var require: any;
declare var window: any;
//const $ = require("jquery");
const plugitWhite = require("../../../Assets/imgs/logo-white.png") as string;
const plugitBlue = require("../../../Assets/imgs/logo-dark.png") as string;
//const sun = require("../../../Assets/imgs/sun.png") as string;
//const moon = require("../../../Assets/imgs/moon.png") as string;
const $ = require("jquery");
export interface TopBarProps {
    Logout: any;
    push: any;
    Login: any;
    ChangeLanguage: any;
    enableDarkTheme: any;
    enableLightTheme: any;
    history: any;
    LangselectedOption: ReduxTypes.LanguageOption;
    userData: IUserData;
    lang: string;
    theme: any;
    router: any;
    CompanySettings: LoadCompanyLogoResult;
    t: any;
    i18n: any;
    CompanyData: ReduxTypes.ICompanyData;
    ConfigCompanyData: GetCompanyDataResult;
}
export interface TopBarState {
}

const mapStateToProps = (state: ReduxTypes.IStore) => ({
    userData: state.auth.UserData,
    history: state.history,
    LangselectedOption: state.language,
    lang: state.language.value,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme,
    router: state.router,
    CompanySettings: state.CompanySettings,
    location: state.router.location,
    CompanyData: state.auth.CompanyData,
    ConfigCompanyData: state.CompanyData,
});
const dispatchProps = { push, Login, Logout, ChangeLanguage, enableLightTheme, enableDarkTheme }


document.addEventListener(
    'touchmove',
    function (e) {
        e.preventDefault();
    },
    false
);
class TopBar extends React.Component<TopBarProps, TopBarState> {
    state = {
        value: 1, username: "", open: false, darkTheme: false, lightTheme: false, mixTheme: false, openProfile: false, OpenMail: false, openPassword: false, openLangauge: false, openLinks: false, openNotification: false, openProfileMainAdmin: false, openProfileNotification: false, visible: false,
        LightLogo: '',
        DarkLogo: '',
        IsCircular: false, website: '', enableTheme: false


    };

    componentDidMount() {
        this.setState({ LightLogo: this.props.CompanySettings.LightLogo });
        this.setState({ DarkLogo: this.props.CompanySettings.DarkLogo });
        this.setState({ IsCircular: this.props.CompanySettings.IsCircular });
        this.setState({ website: this.props.CompanySettings.CompanySite });
        document.addEventListener("keydown", this.escFunction, false);
        document.documentElement.setAttribute('lang', this.props.LangselectedOption.value);
        if (this.props.LangselectedOption.value === "ar") {
            document.documentElement.setAttribute('dir', "rtl");
        }
        else {
            document.documentElement.setAttribute('dir', "ltr");
        }
        if (window.location.toString().includes("Documentation")) {
            $('.Documentation').addClass('activeNav');
            $('.Subscriptions').removeClass('activeNav');
            $('.ServiceDesk').removeClass('activeNav');
            $('.Pay').removeClass('activeNav');
        }
        else if (window.location.toString().includes("Subscriptions")) {
            $('.Subscriptions').addClass('activeNav');
            $('.Documentation').removeClass('activeNav');
            $('.ServiceDesk').removeClass('activeNav');
            $('.Pay').removeClass('activeNav');
        }
        else if (window.location.toString().includes("ServiceDesk")) {
            $('.ServiceDesk').addClass('activeNav');
            $('.Documentation').removeClass('activeNav');
            $('.Subscriptions').removeClass('activeNav');
            $('.Pay').removeClass('activeNav');
        }
        else if (window.location.toString().includes("Pay")) {
            $('.ServiceDesk').removeClass('activeNav');
            $('.Documentation').removeClass('activeNav');
            $('.Subscriptions').removeClass('activeNav');
            $('.Pay').addClass('activeNav');
        }
        if (this.props.theme.currentTheme === 'addons-Dark')
            this.setState({ enableTheme: true })
        else if (this.props.theme.currentTheme === 'addons-Light')
            this.setState({ enableTheme: false })

    }
    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };
    escFunction = (event: any) => {
        if (event.keyCode === 27) {
            this.closeTheme();
        }
    }
    onLogout = (e: any) => {
        DisplayZendDeskChat(false);
        //this.props.Logout();//AS all done in Signin page 
        this.props.push('/login');
        //localStorage.clear();
        //window.location.reload();
    }

    onLanguageChange = (selectedLanguage: any) => {
        if (window.location.href.indexOf("Documentation") > -1) {
            this.navigateToDocuments()
        }
        this.props.ChangeLanguage(DictlanguagesOptions[selectedLanguage]);
        this.props.i18n.changeLanguage(selectedLanguage);
        document.documentElement.setAttribute('lang', selectedLanguage.value);
        if (selectedLanguage === "ar") {
            document.documentElement.setAttribute('dir', "rtl");
        }
        else {
            document.documentElement.setAttribute('dir', "ltr");
        }
    }

    enableDarkTheme = () => {
        this.setState({
            enableTheme: true,
            darkTheme: true,
            lightTheme: false,
        });
        this.props.enableDarkTheme();


    }

    enableLightTheme = () => {
        this.setState({
            enableTheme: false,
            darkTheme: false,
            lightTheme: true,
        });

        this.props.enableLightTheme();

    }

    openProfileMainAdmin = () => {
        this.setState({ openProfileMainAdmin: true })
    }
    openProfileMain = () => {
        this.setState({ openProfile: true })
    }
    closeProfileMainAdmin = () => {
        this.setState({ openProfileMainAdmin: false })
    }
    closeProfileMain = () => {
        this.setState({ openProfile: false })
    }
    handleOpen = () => {
        this.setState({ open: !this.state.open })
    }
    closeTheme = () => {
        this.setState({ open: false })
    }

    enableTheme = () => {
        if (this.state.enableTheme) {
            this.enableLightTheme();
        }
        else {
            this.enableDarkTheme();
        }
    }
    navigateToDocuments = () => {
        this.props.push('/Documentation');
    }
    navigateToSubscriptions = () => {
        this.props.push('/Subscriptions');
    }
    navigateToServiceDesk = () => {
        this.props.push('/ServiceDesk');
    }
    navigateToPay = () => {
        this.props.push('/Pay');
    }
    render() {
        return (
            <div className="sticky-top bg-dark-yoonit h48 topbar">
                <Navbar expand className=" sticky-top h48 darkMenu topbarBottom">
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={this.state.website === "" ? "https://plugitapps.com/" : this.state.website}
                    >

                        <img
                            src={this.props.theme.currentTheme === "addons-Light" ? plugitBlue : plugitWhite}
                            alt="logo"
                        />
                    </a>
                    <div hidden className="barVertical"></div>

                    <Collapse navbar className="d-inline-flex">
                        <Nav className="ml-auto" navbar>
                            <Navbar color="light" light expand="md">
                                <NavbarBrand onClick={this.navigateToDocuments} className="Documentation">{this.props.t('Documentation')}</NavbarBrand>
                                {this.props.userData.isAdmin &&
                                    <NavbarBrand onClick={this.navigateToSubscriptions} className="Subscriptions" >{this.props.t('Subscriptions')}</NavbarBrand>
                                }
                                <NavbarBrand onClick={this.navigateToServiceDesk} className="ServiceDesk" >{this.props.t('ServiceDesk')}</NavbarBrand>
                                {checkIfRevoultPaymentAllowed({ ConfigCompanyData: this.props.ConfigCompanyData, CompanyData: this.props.CompanyData }) && <NavbarBrand onClick={this.navigateToPay} className="Pay" >{this.props.t('Pay')}</NavbarBrand>}
                            </Navbar>
                            {false && <UncontrolledDropdown nav inNavbar id="language2" className="align-self-center mt-1">
                                <span className="d-sm-inline-block hoverIcon">
                                    <DropdownToggle nav caret className="mt2">
                                        <span className=" cursor-default grayColor  ">
                                            <button className="TopbarIconHover">
                                                <FontAwesomeIcon icon={faSlidersH} className="TopbarIcon cursor-pointer hoverIcon" />
                                            </button>
                                        </span>
                                    </DropdownToggle>
                                </span>

                                <DropdownMenu right className="align-self-center ThemeDropDownMenu">
                                    <DropdownItem className="ThemeDropDown">
                                        <FormGroup>
                                            <Label className="LabelCreate d-block wrapText font-16" > {this.props.t('ChooseALanguage')}:</Label>
                                            <FormControl component="fieldset">
                                                <RadioGroup aria-label="language" name="language"
                                                    value={this.props.i18n.language}
                                                    onChange={(e: any) => this.onLanguageChange(e.target.value)}>
                                                    <FormControlLabel value="en" control={<Radio />} label="English" />
                                                    <FormControlLabel value="cn" control={<Radio />} label="中文" />
                                                    <FormControlLabel value="ar" control={<Radio />} label="العربية" />
                                                    <FormControlLabel value="fr" control={<Radio />} label="Français" />
                                                </RadioGroup>
                                            </FormControl>
                                        </FormGroup>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>}
                            <div className="d-inline-flex align-self-center" onClick={this.onLogout}>
                                <Switch checked={this.state.enableTheme} onChange={this.enableTheme} className="SwitchTheme align-self-center" />
                                <FontAwesomeIcon icon={faSignOutAlt} className="signoutIcon cursor-pointer" />
                            </div>
                        </Nav>
                    </Collapse>
                </Navbar >
            </div >
        );
    }

   
}

export default withTranslation()(connect(mapStateToProps, dispatchProps)(TopBar));
